import { Loader } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

export function Spinner({ classMerge }: any): JSX.Element {
  return (
    <Loader
      strokeWidth={2}
      className={twMerge('w-5 h-5 animate-spin', classMerge)}
    />
  )
}
